/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoNoticeSortUpdateRequest model module.
 * @module model/EventsControllerDtoNoticeSortUpdateRequest
 * @version 1.0
 */
class EventsControllerDtoNoticeSortUpdateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoNoticeSortUpdateRequest</code>.
     * @alias module:model/EventsControllerDtoNoticeSortUpdateRequest
     */
    constructor() { 
        
        EventsControllerDtoNoticeSortUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoNoticeSortUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoNoticeSortUpdateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoNoticeSortUpdateRequest} The populated <code>EventsControllerDtoNoticeSortUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoNoticeSortUpdateRequest();

            if (data.hasOwnProperty('sortingIndex')) {
                obj['sortingIndex'] = ApiClient.convertToType(data['sortingIndex'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoNoticeSortUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoNoticeSortUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sortingIndex'] && !(typeof data['sortingIndex'] === 'string' || data['sortingIndex'] instanceof String)) {
            throw new Error("Expected the field `sortingIndex` to be a primitive type in the JSON string but got " + data['sortingIndex']);
        }

        return true;
    }


}



/**
 * @member {String} sortingIndex
 */
EventsControllerDtoNoticeSortUpdateRequest.prototype['sortingIndex'] = undefined;






export default EventsControllerDtoNoticeSortUpdateRequest;

